import {Pipe, PipeTransform} from '@angular/core';
import {StringUtils} from '../util/general/string-utils';

@Pipe({name: 'missingId', standalone: false})
export class MissingIdPipe implements PipeTransform {
  transform(value: string | number | null): string | null {
    return StringUtils.asMissingId(value);
  }
}
